import Button from "components/base/Button";
import { useModals } from "ModalProvider";
import { useContext } from "react";
import CostDefaultSuppliersView from "./CostDefaultSuppliersView";
import { ProductContext } from "./ProductForm";
import ProductPriceRow from "./ProductPriceRow";
import SyncPricesToOdooView from "./SyncPricesToOdooView";

function pricesHasMultipleSuppliersForSameCompany(prices) {
  const companySupplierMap = {};
  prices.forEach((price) => {
    if (!companySupplierMap[price.company]) {
      companySupplierMap[price.company] = new Set();
    }
    if (price.factoryId !== null) {
      companySupplierMap[price.company].add(price.factoryId);
    }
  });

  for (const company in companySupplierMap) {
    if (companySupplierMap[company].size > 1) {
      return true;
    }
  }
  return false;
}

const CostView = () => {
  const { id, product, setProduct } = useContext(ProductContext);
  const modal = useModals();

  const activePrices = product.activePrices || [];

  function addPrice() {
    const newPrices = [
      ...activePrices,
      {
        minQty: 0,
        price: 0,
        company: "AB",
        currency: "USD",
        factoryId: null,
        supplierUpdatedAt: new Date().toISOString().split("T")[0],
      },
    ];
    setProduct((prev) => ({ ...prev, activePrices: newPrices }));
  }

  function onChangePriceRow(index, field, value) {
    setProduct((prev) => {
      const newPrices = [...(prev.activePrices || [])];
      newPrices[index] = { ...newPrices[index], [field]: value };

      const costSuppliers = pricesHasMultipleSuppliersForSameCompany(newPrices)
        ? prev.costSuppliers
        : [];

      return { ...prev, activePrices: newPrices, costSuppliers };
    });
  }

  function onDeletePriceRow(index) {
    setProduct((prev) => {
      const newPrices = prev.activePrices.filter(
        (_, prevIndex) => prevIndex !== index,
      );

      const costSuppliers = pricesHasMultipleSuppliersForSameCompany(newPrices)
        ? prev.costSuppliers
        : [];

      return { ...prev, activePrices: newPrices, costSuppliers };
    });
  }

  function trySyncPrices() {
    modal.present({
      title: "Sync WIS Prices to Odoo",
      children: (
        <SyncPricesToOdooView
          productId={id}
          productOdooId={product.odooId}
          hide={modal.dismiss}
        />
      ),
    });
  }

  console.log("activePrices", activePrices);

  return (
    <div className="card">
      <h5>Cost</h5>
      <div className="space-y-4 mt-4">
        {activePrices.length === 0 && (
          <div className=" opacity-70">
            No active price for this product at the moment.
          </div>
        )}

        {activePrices.length > 0 && (
          <div className="flex-1 -mx-2">
            <table>
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Supplier</th>
                  <th className="text-right">Quantity</th>
                  <th className="text-right">Price</th>
                  <th className="text-right">Currency</th>
                  <th className="text-right">Effective Date</th>
                </tr>
              </thead>
              <tbody>
                {activePrices.map((price, index) => (
                  <ProductPriceRow
                    key={index}
                    price={price}
                    onChange={(field, value) =>
                      onChangePriceRow(index, field, value)
                    }
                    onDelete={() => onDeletePriceRow(index)}
                  />
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="flex items-center justify-between">
          <div className="flex space-x-8">
            <Button onClick={addPrice}>+ Price</Button>

            {product.odooId && (
              <Button odoo onClick={trySyncPrices}>
                Sync WIS Prices to Odoo
              </Button>
            )}
          </div>
        </div>

        {pricesHasMultipleSuppliersForSameCompany(activePrices) && (
          <CostDefaultSuppliersView />
        )}

        {id && (
          <div className="opacity-70">
            To archive prices, please go to the{" "}
            <a
              href={`${process.env.REACT_APP_SERVER_ADMIN_URL}product/product/${id}#prices-group`}
              target="_blank"
            >
              wis Admin
            </a>{" "}
            "Product prices" section.
          </div>
        )}
      </div>
    </div>
  );
};

export default CostView;
